'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _Popup = require('../../../helpers/Popup');

var _popup = require('../../../redux/modules/popup');

var _ = require('../..');

var _DefaultString = require('../../../helpers/DefaultString');

var _AppleLoginError = require('./AppleLoginError.scss');

var _AppleLoginError2 = _interopRequireDefault(_AppleLoginError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppleLoginError = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth, type: state.popup.type };
}, { closePopup: _popup.closePopup }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AppleLoginError, _React$Component);

  function AppleLoginError() {
    (0, _classCallCheck3.default)(this, AppleLoginError);
    return (0, _possibleConstructorReturn3.default)(this, (AppleLoginError.__proto__ || (0, _getPrototypeOf2.default)(AppleLoginError)).apply(this, arguments));
  }

  (0, _createClass3.default)(AppleLoginError, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var buttonTheme = _Popup.Popup.buttonTheme(this.props.auth.productName);
      return _react2.default.createElement(
        'div',
        { className: _AppleLoginError2.default.content },
        _react2.default.createElement(
          'div',
          { className: _AppleLoginError2.default.title },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.AppleLoginErrorTitle)
        ),
        _react2.default.createElement(
          'div',
          { className: _AppleLoginError2.default.message },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.AppleLoginErrorDescription)
        ),
        _react2.default.createElement(_.BaseButton, {
          onClick: function onClick() {
            _this2.props.closePopup();
          },
          buttonString: _DefaultString.translations.Ok,
          className: _AppleLoginError2.default.okButton,
          theme: buttonTheme
        })
      );
    }
  }]);
  return AppleLoginError;
}(_react2.default.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  closePopup: _react.PropTypes.func
}, _temp)) || _class);
exports.default = AppleLoginError;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/AppleLoginError/AppleLoginError.js
// module id = 1965
// module chunks = 0